import { QueryClientProvider } from '@tanstack/react-query'
import type { PropsWithChildren } from 'react'

import { queryClient } from '@/services/api/queryClient'
import { AuthProvider } from '@/services/auth/AuthProvider'
import { EventsProvider } from '@/services/events/EventsProvider'
import { PeriodProvider } from '@/services/period/PeriodProvider'
import { ThemeProvider } from '@/services/theme/ThemeProvider'

/** Порядок важен: AuthProvider использует QueryClient, остальные независимы. */
export function AppProviders({ children }: PropsWithChildren) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <PeriodProvider>
            <EventsProvider>{children}</EventsProvider>
          </PeriodProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}
